import React from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { useSelector } from 'react-redux'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import NewsTickerControlButtonContainer from 'redux/containers/pages/dashboard/NewsTickerControlButtonContainer'
import onClickOutside from 'react-onclickoutside'
import selectCmsCtx from 'redux/selectors/selectCmsCtx'
import NewsTickerTextCms from 'pages/dashboard/NewsTickerTextCms'

const rootRef = { current: null }

const NewsTicker = ({ resumeNewsTicker, aol }) => {
  NewsTicker.handleClickOutside = () => resumeNewsTicker()

  const { isLargeDesktop } = useSelector(selectDeviceType)
  const { width, ref } = useResizeDetector()

  return (
    <div ref={rootRef} className='bg-twilight-grey h-100 flex items-center'>
      <div className='h-100 bg-dark-cerulean flex items-center grow-0 shrink-0'>
        {isLargeDesktop ? <div className='ph4 white f5'>Updates</div> : <NewsTickerControlButtonContainer />}
      </div>
      <div ref={ref} className='black shrink-1 grow-1 basis0 relative overflow-hidden h-100 f6 w-100'>
        <ResizeNewsTickerTextCms aol={aol} width={width} />
      </div>
    </div>
  )
}

const ResizeNewsTickerTextCms = ({ width, aol }) => {
  const cmsCtx = useSelector(selectCmsCtx)

  return (
    <div className='w-100'>
      {cmsCtx && aol && <NewsTickerTextCms {...{ cmsCtx, width, aol }} />}
    </div>
  )
}

const clickOutsideConfig = {
  handleClickOutside: () => NewsTicker.handleClickOutside,
  // Without this, react-onclickoutside falls back to the deprecated
  // findDOMNode() to locate this component's DOM node, since NewsTicker is a
  // function component with no instance for the library to grab a ref from
  // directly. Handing it our own ref instead avoids that entirely - contract
  // per the library's source (react-onclickoutside.es.js): setClickOutsideRef()
  // must return a function that resolves the node (the `instance` it's
  // called with isn't needed here since we already have our own ref).
  setClickOutsideRef: () => () => rootRef.current
}

export default onClickOutside(NewsTicker, clickOutsideConfig)
